<template>
  <EmdFormGroup
    :label="$t('reference-point')"
    :state="getState($v.recipient.reference_point)"
    :feedbacks="feedbacks($v.recipient.reference_point)"
  >
    <EmdInput
      @input="() => $v.recipient.reference_point.$touch()"
      v-model="recipient.reference_point"
      name="reference-point"
      :readonly="disabled"
      :disabled="disabled"
    />
  </EmdFormGroup>
</template>

<script>
import { EmdFormGroup, EmdInput } from 'emerald-vue/src/components'
import { getState, feedbacks } from '@/utils/form.utils'
import { address } from '../validations'
export default {
  name: 'MainAddressReferencePointInput',
  components: {
    EmdFormGroup,
    EmdInput
  },
  data: () => ({
    getState,
    feedbacks,
    reference_point: ''
  }),
  props: {
    recipient: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  validations () {
    return { recipient: address }
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "reference-point": "Ponto de referência"
    },
    "en-US": {
      "reference-point": "Reference point"
    }
  }
</i18n>
